import { ControlValueAccessor } from '@angular/forms';

/**
 * Represents an abstract `FnInputValueAccessor` class `T`, for writing a value and listening to changes for class extending this class.
 * @template T Represents a type that a Component or other object is instances of.
 */

export abstract class FnInputValueAccessor<T> implements ControlValueAccessor {
	/**
	 * private member variable
	 * store the value inserted or enterd in form Field.
	 */
	private innerValue: T;

	/**
	 * public member variable
	 * used to disable and enable input Field.
	 * if true then disable and flase then enable user to enter text in input field.
	 * default value is false.
	 */
	isDisabled = false;

	/**
	 * public member varible of any type.
	 * used to store the callback function to register get from registerOnChange  implemented method.
	 */
	public propagateChange: any = () => {};

	/**
	 * public member varible of any type.
	 * used to store the callback function to register get from registerOnTouched implemented method.
	 * and call to
	 */
	public propagateTouched: any = () => {};

	/**
	 * getter method to return innerValue
	 */
	get value(): T {
		return this.innerValue;
	}

	/**
	 * setter method to set innerValue and call propagateChange method.
	 */
	set value(value: T) {
		if (this.innerValue !== value) {
			this.innerValue = value;
			this.propagateChange(value);
		}
	}

	/**
	 * Implementing registerOnChange method of ControlValueAccessor.
	 * This method is called by the forms API to write to the view when programmatic changes from model
	 * to view are requested to innerValue Variable.
	 * @param value The new value for the element
	 */
	writeValue(value: T) {
		this.innerValue = value;
	}

	/**
	 * Implementing registerOnChange method of ControlValueAccessor to get Callback function on input element value is changed.
	 * @param fn The callback function to register
	 */
	registerOnChange(fn: (value: T) => void) {
		this.propagateChange = fn;
	}

	/**
	 * Implementing registerOnTouched method of ControlValueAccessor to get Callback function on input element is touched.
	 * @param fn The callback function to register
	 */
	registerOnTouched(fn: () => void) {
		this.propagateTouched = fn;
	}

	/**
	 * Implementing setDisabledState method of ControlValueAccessor
	 * Function that is called by the forms API when the control status changes to or from 'DISABLED'.
	 * Depending on the status, it enables or disables the appropriate DOM element.
	 * @param disabled 	The disabled status to set on the element
	 */
	setDisabledState(disabled: boolean): void {
		this.isDisabled = disabled;
	}
}
